import React, { useState } from "react"
import { Card, Typography, Space, Divider } from "antd"
import { BugOutlined } from "@ant-design/icons"
import { PatternTestInput } from "./PatternTestInput"
import { PatternTestResults } from "./PatternTestResults"
import { BlacklistPattern } from "./types"

const { Text } = Typography

export interface PatternTesterProps {
  patterns: BlacklistPattern[]
}

export const PatternTester: React.FC<PatternTesterProps> = ({ patterns }) => {
  const [testString, setTestString] = useState("")

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <BugOutlined style={{ color: "#722ed1" }} />
          <Text strong>Pattern Tester</Text>
        </div>
      }
      style={{ marginTop: 16 }}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Test your blacklist patterns against real error messages to ensure they work as expected.
            Copy an error from Sentry and paste it below to see which patterns would match.
          </Text>
        </div>

        <PatternTestInput
          value={testString}
          onChange={setTestString}
        />

        <Divider style={{ margin: "16px 0" }} />

        <PatternTestResults
          patterns={patterns}
          testString={testString}
        />
      </Space>
    </Card>
  )
}
